<div class="box-shadow module">
    <h3>Please wait while we are redirecting you to the login page...</h3>
</div>